var reliefCodeView = angular.module('taric.relief.view', ['taric.model.menu', 'common.helper'])
    .controller('ReliefCodeViewController', function (CONSTANTS, reliefCodeDetail, CommonHelper, $rootScope, $scope, $filter, $stateParams) {
        var reliefCodeViewCtrl = this;
        reliefCodeViewCtrl.init = function(){
            reliefCodeViewCtrl.dateFormat = CONSTANTS.dateFormat;
            reliefCodeViewCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            reliefCodeViewCtrl.reliefCodeType = reliefCodeDetail.reliefCode.substring(0, 1);
            reliefCodeViewCtrl.reliefCode = reliefCodeDetail.reliefCode.substring(1);
            reliefCodeViewCtrl.startDate = reliefCodeDetail.startDate;
            reliefCodeViewCtrl.endDate = reliefCodeDetail.endDate;
            reliefCodeViewCtrl.descriptions = reliefCodeDetail.descriptions;
            reliefCodeViewCtrl.reliefs = reliefCodeDetail.reliefs;
        };

        reliefCodeViewCtrl.print = function(options) {
            $rootScope.$broadcast('startSpinningPrint');
            $scope.$apply();

            // load documents
            var doc = [];
            CommonHelper.htmlTableToPdf(doc, document.getElementById('reliefCodeInformation'), options);

            var reliefAreas = document.getElementsByClassName("relief-area");
            if (reliefAreas){
                for (let i = 0; i < reliefAreas.length; i++) {
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, reliefAreas[i].getElementsByClassName("relief-table")[0] , options);
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, reliefAreas[i].getElementsByClassName("measure-type-duty-expr-table")[0] , options);
                }
            }
            CommonHelper.printPlainDocument({
                contents: doc,
                logo: options.logo,
                validDate: $filter('date')($stateParams.sd, CONSTANTS.dateFormat),
                title: $filter('translate')('i8n.report.reliefCode.view.title')
            }, 'l').then(() => {
                $rootScope.$broadcast('stopSpinningPrint');
            }, (error) => {
                $rootScope.$broadcast('stopSpinningPrint');
            });
        };

        $scope.$on('printDocument', function(event, data) {

            // preload logo of the report
            // size of logo must be multiplied by 2 because it will increase resolution
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, reliefCodeViewCtrl.print, true);

        });

    });


// WEBPACK FOOTER //
// ./app/taric/report/relief/view/relief-code-view.js